import CaregiverExclusionsPage from "./CaregiverExclusionsPage";

export default function CaregiverExclusionsRoute() {
  return <CaregiverExclusionsPage />;
}
